const getRemotePaths = () => {
  const defaults = {
    development: {
      API_PATH: 'https://kc-connect.appunite.com',
      CALL_WS_PATH: 'wss://kc-connect.appunite.net/calls/ws',
    },

    testing: {
      API_PATH: 'https://kc-connect.appunite.com',
      CALL_WS_PATH: 'wss://connect-kc.appunite.net/calls/ws',
    },

    production: {
      API_PATH: 'https://connect.kingsch.at',
      CALL_WS_PATH: 'wss://connect.kingsch.at/calls/ws',
    },
  }

  const ENV =
    window.ENV !== '$ENV'
      ? JSON.parse(window.ENV)
      : {
          // for local use only
          ...defaults['testing'],
        }

  return {
    ...ENV,
  }
}

export const REMOTE_PATHS = getRemotePaths()
